'use client';

import { UIComponent } from '@/components/core/components';
import PeoopleMap from '@/components/core/components/organism/map';
import { useUser } from '@/components/context/user';
import { useCallback, useRef, useState } from 'react';
import { ProductOfCategory } from '@/@types';
import { Trans } from '@lingui/react/macro';
import * as styles from './map.styles';
import Subtitle from '../subtitle';

const HomeMap: UIComponent = () => {
  const { api } = useUser();
  const timeout = useRef<ReturnType<typeof setTimeout>>();

  const [markers, setMarkers] = useState<ProductOfCategory<'restaurants' | 'places'>[]>([]);
  const onChange = useCallback(
    (mapOptions) => {
      if (!mapOptions.center) {
        return;
      }
      setMarkers([]);
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        api
          ?.exploreNear({
            latitud: mapOptions.center.lat,
            longitud: mapOptions.center.lng,
            delta: mapOptions.delta,
          })
          .then(setMarkers);
      }, 500);
    },
    [api],
  );

  return (
    <div className={styles.root}>
      <Subtitle>
        <Trans>What do you recommend near me?</Trans>
      </Subtitle>
      <div className={styles.mapContainer}>
        <PeoopleMap markers={markers} onChange={onChange} onLoad={onChange} />
      </div>
    </div>
  );
};

export default HomeMap;
